'use strict';
module.exports = require('./SpeedDial.vue');